document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-evolution-container]');
  if (!container) return;

  const video = container.querySelector('video');
  const btn = container.querySelector('[data-evolution-play-btn]');
  if (!video || !btn) return;

  const pauseIcon = btn.querySelector('[data-evolution-pause-icon]');
  const playIcon = btn.querySelector('[data-evolution-play-icon]');

  let hideTimer = null;

  const hideBtn = () => {
    btn.classList.add('is-hidden');
  };

  const showBtn = () => {
    btn.classList.remove('is-hidden');
  };

  const scheduleHide = () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideBtn, 3000);
  };

  const showPauseState = () => {
    pauseIcon.style.display = '';
    playIcon.style.display = 'none';
    btn.setAttribute('aria-label', 'Pause video');
    showBtn();
    scheduleHide();
  };

  const showPlayState = () => {
    pauseIcon.style.display = 'none';
    playIcon.style.display = '';
    btn.setAttribute('aria-label', 'Play video');
    clearTimeout(hideTimer);
    showBtn();
  };

  video.addEventListener('play', showPauseState);
  video.addEventListener('pause', showPlayState);

  btn.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  video.addEventListener('click', () => {
    if (!video.paused) {
      video.pause();
    }
  });
});
